module.exports = __webpack_public_path__ + "static/img/08jingya.7fd48d5c.gif";